import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { MyDayPage } from '../../components/my-day/MyDayPage';
import { PreviewPage } from '../../components/preview/PreviewPage';

// Standalone app pages. The framework header is turned off; each page lays
// out its own content. The `/architecture` redirect is not an extension: it is
// configured under `app.extensions` in `app-config.yaml`.
export const pagesModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    PageBlueprint.make({
      name: 'my-day',
      params: {
        path: '/my-day',
        noHeader: true,
        loader: async () => <MyDayPage />,
      },
    }),
    PageBlueprint.make({
      name: 'preview',
      params: {
        path: '/preview',
        noHeader: true,
        loader: async () => <PreviewPage />,
      },
    }),
    // Deliberate exception to the eager-import norm for plugin pages: this
    // diagnostic page imports `brandedTokens` from the `@easyparkgroup/rally-web`
    // barrel, which drags the entire Rally component library in. Eagerly
    // importing it would put that weight in the *main* bundle for every user on
    // every page, to power a troubleshooting route that isn't even on the
    // sidebar. Loading it on demand code-splits rally-web into a chunk that only
    // loads when someone visits `/rally-tokens`. (PAT-478, which brands the
    // actual portal, will import the same thing eagerly — there the weight
    // benefits everyone.)
    PageBlueprint.make({
      name: 'rally-tokens',
      params: {
        path: '/rally-tokens',
        noHeader: true,
        loader: () =>
          import('../../components/rallyTokens/RallyTokensPage').then(m => (
            <m.RallyTokensPage />
          )),
      },
    }),
  ],
});
